import React from "react"
import { Box, Chip, Dialog, DialogTitle, DialogContent, IconButton, Typography } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { useSignal } from "@preact/signals-react"

const MAX_VISIBLE = 3

export default function ReportsNameCell({ value }) {
	const open = useSignal(false)

	if (!Array.isArray(value) || value.length === 0) {
		return <Box sx={{ textAlign: 'center' }}>-</Box>
	}

	const visible = value.slice(0, MAX_VISIBLE)
	const hidden = value.length - MAX_VISIBLE

	return (
		<Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 0.5 }}>
			{visible.map((item, idx) => <Chip key={idx} label={item} size="small" sx={{ m: 0.25 }}/>)}
			{hidden > 0 && (
				<Chip
					label={`+${hidden}`}
					size="small"
					color="primary"
					onClick={e => { e.stopPropagation(); open.value = true }}
					sx={{ m: 0.25, cursor: 'pointer' }}
				/>
			)}
			<Dialog open={open.value} onClose={() => open.value = false} maxWidth="xs" fullWidth>
				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography variant="h6">Reports</Typography>
					<IconButton size="small" onClick={() => open.value = false}>
						<CloseIcon fontSize="small"/>
					</IconButton>
				</DialogTitle>
				<DialogContent dividers>
					<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
						{value.map((item, idx) => <Chip key={idx} label={item} size="small" sx={{ m: 0.25 }}/>)}
					</Box>
				</DialogContent>
			</Dialog>
		</Box>
	)
}